export interface Movie {
  id: number;
  title: string;
  titleEn: string;
  category: 'japan' | 'korea' | 'theater' | 'anime';
  year: number;
  rating: number;
  director: string;
  cast: string[];
  duration: string;
  description: string;
  longDescription: string;
  tags: string[];
  coverImage: string;
  bannerImage: string;
  featured: boolean;
  releaseDate: string;
  views: number;
}

export const movies: Movie[] = [
  {
    id: 1,
    title: '铃芽之旅',
    titleEn: 'Suzume no Tojimari',
    category: 'anime',
    year: 2022,
    rating: 8.3,
    director: '新海诚',
    cast: ['原菜乃华', '松村北斗', '深津绘里'],
    duration: '122分钟',
    description: '生活在九州乡下的17岁少女铃芽，遇见了一位为寻找"门"而踏上旅途的青年。追随着青年的脚步，铃芽来到了山中废墟，发现了一扇古老的门。',
    longDescription: '《铃芽之旅》是新海诚导演继《你的名字。》《天气之子》后的最新力作。故事讲述17岁少女岩户铃芽在日本各地关闭灾难源头之"门"的冒险旅程。影片以壮丽的视觉效果呈现日本各地的风光，同时探讨了自然灾害、记忆与重建的主题。上映后不仅在日本创下票房纪录，也在中国引起了强烈反响，被誉为新海诚的集大成之作。影片将公路片的叙事结构与奇幻元素巧妙融合，配合RADWIMPS的音乐，带来震撼的视听体验。',
    tags: ['动画', '奇幻', '冒险', '新海诚'],
    coverImage: 'https://readdy.ai/api/search-image?query=A%20beautiful%20anime%20movie%20poster%20style%20image%20of%20a%20young%20Japanese%20girl%20standing%20in%20front%20of%20a%20mysterious%20glowing%20door%20in%20a%20ruined%20landscape%2C%20soft%20dreamy%20lighting%2C%20cinematic%20composition%2C%20gentle%20blue%20and%20warm%20golden%20tones%2C%20minimalist%20clean%20background&width=400&height=560&seq=movie-cover-01&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Epic%20anime%20landscape%20with%20a%20young%20girl%20traveling%20through%20beautiful%20Japanese%20countryside%2C%20dramatic%20sky%20with%20warm%20sunset%20colors%2C%20cinematic%20widescreen%20composition%2C%20soft%20atmospheric%20lighting%2C%20detailed%20background%20art&width=1600&height=700&seq=movie-banner-01&orientation=landscape',
    featured: true,
    releaseDate: '2023-03-24',
    views: 158000,
  },
  {
    id: 2,
    title: '寄生虫',
    titleEn: 'Parasite',
    category: 'korea',
    year: 2019,
    rating: 9.0,
    director: '奉俊昊',
    cast: ['宋康昊', '李善均', '赵汝贞', '崔宇植'],
    duration: '132分钟',
    description: '一家四口全是无业游民，偶然机会长子通过伪造学历成为富豪家庭的家教，由此引发一连串出人意料的事件。',
    longDescription: '《寄生虫》是奉俊昊导演的黑色幽默惊悚片，荣获第92届奥斯卡金像奖最佳影片、最佳导演、最佳原创剧本、最佳国际影片四项大奖，创造了韩国电影乃至亚洲电影的历史。影片通过两个贫富悬殊家庭的交织，深刻揭示了社会阶层固化的残酷现实。奉俊昊以其标志性的类型混合手法，将喜剧、悬疑、惊悚无缝融合，每一个场景都充满张力与隐喻。地下室、楼梯、气味等视觉符号的运用堪称教科书级别，使这部作品成为当代电影的里程碑。',
    tags: ['剧情', '悬疑', '黑色幽默', '奥斯卡'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20movie%20poster%20style%20with%20a%20mysterious%20dramatic%20family%20standing%20in%20front%20of%20a%20modern%20luxury%20house%2C%20dark%20atmospheric%20mood%2C%20strong%20contrast%20between%20light%20and%20shadow%2C%20cinematic%20film%20poster%20aesthetic&width=400&height=560&seq=movie-cover-02&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Luxury%20modern%20Korean%20mansion%20with%20contrasting%20dark%20basement%20stairs%2C%20dramatic%20chiaroscuro%20lighting%2C%20rainy%20atmosphere%2C%20cinematic%20film%20noir%20style%2C%20tension%20filled%20composition&width=1600&height=700&seq=movie-banner-02&orientation=landscape',
    featured: true,
    releaseDate: '2019-05-30',
    views: 210000,
  },
  {
    id: 3,
    title: '灌篮高手',
    titleEn: 'The First Slam Dunk',
    category: 'anime',
    year: 2022,
    rating: 8.7,
    director: '井上雄彦',
    cast: ['仲村宗悟', '笠间淳', '神尾晋一郎'],
    duration: '124分钟',
    description: '宫城良田、三井寿、流川枫、樱木花道、赤木刚宪，湘北高中篮球部的五名成员在篮球场上挥洒青春热血。',
    longDescription: '《灌篮高手》大电影由原作漫画家井上雄彦亲自执导，聚焦全国大赛中湘北对阵山王工业的经典一役。影片以宫城良田的视角展开，穿插每位队员的成长故事，用全新3D渲染2D技术呈现出令人窒息的篮球比赛场面。节奏紧凑、动作流畅，每一个传球、投篮都充满力量感。对于无数80后、90后来说，这不仅是一部电影，更是青春的完美句号。上映后在中国掀起观影热潮，成为现象级动画电影。',
    tags: ['动画', '运动', '热血', '青春'],
    coverImage: 'https://readdy.ai/api/search-image?query=Basketball%20anime%20movie%20poster%20with%20five%20players%20in%20red%20jerseys%20on%20a%20basketball%20court%2C%20dynamic%20action%20pose%2C%20dramatic%20spotlight%20effect%2C%20energetic%20sports%20atmosphere%2C%20clean%20vibrant%20colors&width=400&height=560&seq=movie-cover-03&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Intense%20basketball%20game%20in%20a%20packed%20stadium%2C%20dramatic%20sports%20photography%20style%2C%20dynamic%20player%20movement%20with%20motion%20blur%2C%20bright%20arena%20lights%2C%20energetic%20atmosphere&width=1600&height=700&seq=movie-banner-03&orientation=landscape',
    featured: true,
    releaseDate: '2023-04-20',
    views: 189000,
  },
  {
    id: 4,
    title: '老手2',
    titleEn: 'Veteran 2',
    category: 'korea',
    year: 2024,
    rating: 7.8,
    director: '柳承完',
    cast: ['黄政民', '丁海寅', '吴达洙'],
    duration: '118分钟',
    description: '老刑警徐道哲与新晋刑警朴善宇联手追查一起跨国犯罪案件，在追捕过程中逐渐揭露背后庞大的黑暗势力。',
    longDescription: '《老手2》延续了前作的硬派动作风格，黄政民再次饰演不按常理出牌的老刑警徐道哲。本片加入了丁海寅饰演的新角色朴善宇，新老搭档之间的化学反应为影片增添了新鲜感。动作场面全面升级，追车戏和近身格斗的设计更加国际化。影片在保持韩式犯罪片特有的幽默感的同时，也深入探讨了正义与法律的边界问题。2024年韩国暑期档最受期待的犯罪动作大片。',
    tags: ['动作', '犯罪', '警匪', '续作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20crime%20action%20movie%20poster%20featuring%20two%20detectives%20in%20dark%20urban%20setting%2C%20gritty%20noir%20atmosphere%2C%20rain%20soaked%20streets%2C%20dramatic%20lighting%2C%20intense%20expressions&width=400&height=560&seq=movie-cover-04&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Night%20cityscape%20of%20Seoul%20with%20police%20cars%20and%20dramatic%20neon%20lights%2C%20rainy%20street%20reflections%2C%20gritty%20urban%20crime%20atmosphere%2C%20cinematic%20noir%20lighting&width=1600&height=700&seq=movie-banner-04&orientation=landscape',
    featured: true,
    releaseDate: '2024-07-31',
    views: 95000,
  },
  {
    id: 5,
    title: '完美的日子',
    titleEn: 'Perfect Days',
    category: 'japan',
    year: 2023,
    rating: 8.1,
    director: '维姆·文德斯',
    cast: ['役所广司', '柄本时生', '中野有纱'],
    duration: '123分钟',
    description: '东京一位公共厕所清洁工的日常生活，他在重复的日常中寻找美与宁静，展现了一个平凡人内心的丰富世界。',
    longDescription: '德国导演维姆·文德斯执导的日本电影《完美的日子》，由役所广司主演，荣获戛纳电影节最佳男演员奖。影片以极为细腻的手法描绘了一位东京公厕清洁工平山的日常生活，他在清晨醒来、照顾植物、开车上班、清扫厕所、在公园吃午餐、去澡堂泡澡——看似单调的循环中，却蕴含着对生活最深的热爱与感恩。文德斯以日本"侘寂"美学为基调，用4:3画幅和精妙的构图，呈现出一首关于日常之美的视觉诗篇。',
    tags: ['剧情', '文艺', '生活', '戛纳'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20art%20film%20poster%20with%20an%20elderly%20man%20looking%20peacefully%20at%20the%20sky%2C%20minimalist%20composition%2C%20warm%20natural%20sunlight%2C%20contemplative%20mood%2C%20clean%20simple%20aesthetic&width=400&height=560&seq=movie-cover-05&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Peaceful%20Tokyo%20morning%20scene%20with%20soft%20sunlight%20filtering%20through%20trees%2C%20quiet%20residential%20neighborhood%2C%20warm%20golden%20hour%20light%2C%20serene%20atmospheric%20Japanese%20urban%20landscape&width=1600&height=700&seq=movie-banner-05&orientation=landscape',
    featured: false,
    releaseDate: '2023-12-22',
    views: 42000,
  },
  {
    id: 6,
    title: '哥斯拉-1.0',
    titleEn: 'Godzilla Minus One',
    category: 'japan',
    year: 2023,
    rating: 8.5,
    director: '山崎贵',
    cast: ['神木隆之介', '滨边美波', '山田裕贵'],
    duration: '125分钟',
    description: '战后日本从零开始重建之际，哥斯拉的出现将已经一无所有的日本推向了更加绝望的深渊。',
    longDescription: '《哥斯拉-1.0》是哥斯拉系列诞生70周年的纪念作品，以战后日本为舞台，讲述了一个关于创伤、勇气与重生的故事。影片凭借约1500万美元的制作成本，打造出了令人震撼的视觉特效，并荣获第96届奥斯卡最佳视觉效果奖——这是哥斯拉系列首次获得奥斯卡。山崎贵导演将灾难片的壮观场面与深沉的人文关怀完美结合，神木隆之介的表演也获得广泛好评。片中哥斯拉的热射线场景在IMAX银幕上极具压迫感。',
    tags: ['科幻', '灾难', '怪兽', '奥斯卡'],
    coverImage: 'https://readdy.ai/api/search-image?query=Godzilla%20movie%20poster%20with%20giant%20monster%20silhouette%20against%20burning%20city%20skyline%2C%20dramatic%20orange%20and%20black%20color%20scheme%2C%20destruction%20and%20chaos%2C%20epic%20scale%20composition&width=400&height=560&seq=movie-cover-06&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Post%20war%20Japanese%20city%20being%20destroyed%20by%20a%20giant%20monster%2C%20epic%20disaster%20scene%20with%20orange%20explosions%20and%20smoke%2C%20cinematic%20chaos%2C%20dramatic%20apocalyptic%20sky&width=1600&height=700&seq=movie-banner-06&orientation=landscape',
    featured: true,
    releaseDate: '2023-11-03',
    views: 135000,
  },
  {
    id: 7,
    title: '破墓',
    titleEn: 'Exhuma',
    category: 'korea',
    year: 2024,
    rating: 7.5,
    director: '张宰贤',
    cast: ['崔岷植', '金高银', '李到晛', '柳海真'],
    duration: '134分钟',
    description: '风水师、入殓师和巫师受雇于一个富裕家庭，前往一处偏远墓地迁葬，却意外释放了被封印的邪恶力量。',
    longDescription: '《破墓》是2024年韩国最受关注的超自然恐怖片，融合了韩国民俗信仰、风水学和萨满教元素。崔岷植饰演经验丰富的风水师，金高银饰演年轻巫师，两人在调查一座神秘坟墓时逐渐揭开跨越数代的恐怖秘密。导演张宰贤以《娑婆诃》展现了其对宗教恐怖题材的掌控力，本片更是将视觉效果与心理恐惧推向了新的高度。上映后口碑票房双丰收，被誉为近年来最好的韩国恐怖片之一。',
    tags: ['恐怖', '悬疑', '超自然', '民俗'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20horror%20movie%20poster%20with%20a%20mysterious%20ancient%20grave%20in%20a%20dark%20forest%2C%20eerie%20supernatural%20atmosphere%2C%20foggy%20mountain%20setting%2C%20dark%20muted%20earth%20tones%2C%20ominous%20mood&width=400&height=560&seq=movie-cover-07&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20ancient%20Korean%20grave%20site%20in%20remote%20forest%20with%20thick%20fog%2C%20eerie%20supernatural%20atmosphere%2C%20dark%20mountain%20landscape%2C%20cinematic%20horror%20film%20aesthetic&width=1600&height=700&seq=movie-banner-07&orientation=landscape',
    featured: false,
    releaseDate: '2024-02-22',
    views: 118000,
  },
  {
    id: 8,
    title: '你想活出怎样的人生',
    titleEn: 'The Boy and the Heron',
    category: 'anime',
    year: 2023,
    rating: 8.2,
    director: '宫崎骏',
    cast: ['山时聪真', '菅田将晖', '柴咲幸'],
    duration: '124分钟',
    description: '少年牧真人在母亲去世后随父亲搬到乡下，一只会说话的苍鹭将他引入了一个奇幻的世界，开启了一段自我发现的旅程。',
    longDescription: '宫崎骏导演暌违十年的长篇动画新作，荣获第96届奥斯卡最佳动画长片奖。片名取自吉野源三郎的同名小说，但故事是宫崎骏原创的半自传式奇幻作品。影片以其标志性的手绘动画风格，构建了一个充满隐喻的异世界——那里的鹈鹕、鹦鹉和陨石塔都暗含着对生命、战争与创造的思考。这是一部非常私人的作品，是宫崎骏送给孙辈的礼物，也是他对"活出怎样的人生"这一终极命题的回答。久石让的配乐依然是影片的灵魂。',
    tags: ['动画', '奇幻', '冒险', '宫崎骏'],
    coverImage: 'https://readdy.ai/api/search-image?query=Studio%20Ghibli%20style%20anime%20movie%20poster%20with%20a%20boy%20and%20a%20mysterious%20heron%20bird%2C%20whimsical%20fantasy%20world%2C%20soft%20hand%20drawn%20art%20style%2C%20warm%20pastel%20colors%2C%20dreamlike%20atmosphere&width=400&height=560&seq=movie-cover-08&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Whimsical%20Ghibli%20style%20fantasy%20landscape%20with%20floating%20islands%20and%20strange%20creatures%2C%20lush%20green%20nature%2C%20dreamlike%20surreal%20atmosphere%2C%20soft%20hand%20painted%20aesthetic&width=1600&height=700&seq=movie-banner-08&orientation=landscape',
    featured: true,
    releaseDate: '2024-04-03',
    views: 167000,
  },
  {
    id: 9,
    title: '首尔之春',
    titleEn: '12.12: The Day',
    category: 'korea',
    year: 2023,
    rating: 8.3,
    director: '金成洙',
    cast: ['黄政民', '郑雨盛', '李星民'],
    duration: '141分钟',
    description: '1979年12月12日，韩国首都首尔发生军事政变。以全斗光为首的军中秘密组织发动叛乱，试图夺取政权。',
    longDescription: '《首尔之春》以1979年12月12日发生的韩国历史事件为背景，再现了那场改变韩国命运的关键九小时。黄政民饰演的全斗光（原型全斗焕）与郑雨盛饰演的李泰信（原型张泰玩）之间的对峙，展现了权力与正义的激烈碰撞。影片以扎实的剧本、精湛的群像演技和高度还原的历史细节，在韩国引发了巨大的社会讨论，超过1300万观影人次使其成为2023年韩国年度票房冠军。这不仅是一部历史片，更是一面映照当下的镜子。',
    tags: ['历史', '剧情', '政治', '真实事件'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20historical%20political%20drama%20movie%20poster%20with%20military%20officers%20in%20uniform%2C%20tense%20confrontation%20scene%2C%201970s%20aesthetic%2C%20muted%20olive%20and%20khaki%20tones%2C%20serious%20dramatic%20mood&width=400&height=560&seq=movie-cover-09&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Seoul%20cityscape%20at%20night%20during%20winter%201979%2C%20military%20vehicles%20on%20streets%2C%20tense%20historical%20atmosphere%2C%20dark%20moody%20lighting%2C%20retro%201970s%20Korean%20urban%20scene&width=1600&height=700&seq=movie-banner-09&orientation=landscape',
    featured: false,
    releaseDate: '2023-11-22',
    views: 178000,
  },
  {
    id: 10,
    title: '怪物',
    titleEn: 'Monster',
    category: 'japan',
    year: 2023,
    rating: 8.4,
    director: '是枝裕和',
    cast: ['安藤樱', '永山瑛太', '黑川想矢'],
    duration: '126分钟',
    description: '一位母亲发现儿子的行为异常，她认为是学校老师虐待了孩子。但当真相逐渐浮出水面，事情远比想象中复杂。',
    longDescription: '是枝裕和导演的金棕榈获奖编剧坂元裕二强强联手的《怪物》，以多视角叙事（罗生门式结构）展开一个关于偏见、真相与成长的故事。影片从母亲、老师和孩子的三个视角分别讲述同一事件，每一层视角都推翻前一层的认知，最终拼出一个令人心碎又温暖的真相。安藤樱的精湛演技、坂元裕二细腻的剧本以及是枝裕和克制而深情的导演风格，使本片获得戛纳最佳编剧奖和酷儿棕榈奖。',
    tags: ['剧情', '悬疑', '家庭', '戛纳'],
    coverImage: 'https://readdy.ai/api/search-image?query=Japanese%20drama%20movie%20poster%20with%20a%20mother%20and%20child%20silhouette%20against%20a%20window%2C%20emotional%20atmospheric%20lighting%2C%20minimalist%20composition%2C%20soft%20muted%20tones%2C%20contemplative%20mood&width=400&height=560&seq=movie-cover-10&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Quiet%20Japanese%20suburban%20landscape%20with%20a%20school%20building%20at%20sunset%2C%20melancholic%20atmosphere%2C%20soft%20golden%20light%20through%20trees%2C%20peaceful%20yet%20slightly%20unsettling%20mood&width=1600&height=700&seq=movie-banner-10&orientation=landscape',
    featured: false,
    releaseDate: '2023-06-02',
    views: 89000,
  },
  {
    id: 11,
    title: '犯罪都市4',
    titleEn: 'The Roundup: Punishment',
    category: 'korea',
    year: 2024,
    rating: 7.6,
    director: '许明行',
    cast: ['马东锡', '金武烈', '李东辉'],
    duration: '109分钟',
    description: '怪物刑警马锡道这次面对的是高科技网络犯罪集团，他必须用拳头在网络时代伸张正义。',
    longDescription: '《犯罪都市4》延续了马东锡式的硬汉动作喜剧风格，这次的反派升级为精通网络技术的犯罪集团头目白昌基（金武烈饰）。马锡道刑警一如既往地用拳头解决问题，但与高科技犯罪的碰撞带来了全新的笑点与动作场面。系列票房一路走高，前作《犯罪都市3》突破千万观影人次，第四部延续了这股势头。爽快的动作、接地气的幽默和马东锡无可替代的银幕魅力，让这个系列成为韩国最受欢迎的动作IP。',
    tags: ['动作', '犯罪', '喜剧', '续作'],
    coverImage: 'https://readdy.ai/api/search-image?query=Korean%20action%20movie%20poster%20with%20a%20muscular%20detective%20in%20a%20fighting%20stance%2C%20urban%20night%20street%20background%2C%20gritty%20action%20style%2C%20dramatic%20lighting%2C%20intense%20expression&width=400&height=560&seq=movie-cover-11&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Bright%20neon%20lit%20Seoul%20night%20street%20with%20police%20action%20scene%2C%20dynamic%20urban%20energy%2C%20colorful%20signage%2C%20modern%20Korean%20cityscape%20atmosphere&width=1600&height=700&seq=movie-banner-11&orientation=landscape',
    featured: false,
    releaseDate: '2024-04-24',
    views: 142000,
  },
  {
    id: 12,
    title: '名侦探柯南：黑铁的鱼影',
    titleEn: 'Detective Conan: Black Iron Submarine',
    category: 'anime',
    year: 2023,
    rating: 7.9,
    director: '立川让',
    cast: ['高山南', '山崎和佳奈', '小山力也'],
    duration: '110分钟',
    description: '柯南一行人在深海设施中遭遇黑衣组织的阴谋，灰原哀的身份面临暴露的危险，一场惊心动魄的海上对决展开。',
    longDescription: '《名侦探柯南》第26部剧场版《黑铁的鱼影》以深海为舞台，围绕最新AI监控系统展开。本作的核心看点是灰原哀与黑衣组织的正面交锋——她的真实身份险些暴露，柯南与黑衣组织在海中展开了前所未有的对决。影片在日本创下柯南系列最高票房纪录，超过138亿日元。水下动作场面制作精良，剧情紧凑，交织着友情、牺牲与勇气的主题，让粉丝直呼过瘾。',
    tags: ['动画', '推理', '悬疑', '剧场版'],
    coverImage: 'https://readdy.ai/api/search-image?query=Detective%20Conan%20anime%20movie%20poster%20with%20characters%20underwater%20near%20a%20submarine%2C%20mysterious%20deep%20sea%20atmosphere%2C%20dramatic%20blue%20tones%2C%20suspenseful%20mood%2C%20clean%20anime%20art%20style&width=400&height=560&seq=movie-cover-12&orientation=portrait',
    bannerImage: 'https://readdy.ai/api/search-image?query=Mysterious%20deep%20ocean%20scene%20with%20a%20high%20tech%20submarine%20facility%2C%20dark%20blue%20underwater%20lighting%2C%20suspenseful%20atmosphere%2C%20cinematic%20anime%20style%20background%20art&width=1600&height=700&seq=movie-banner-12&orientation=landscape',
    featured: false,
    releaseDate: '2023-12-16',
    views: 124000,
  },
];

export const getMovieById = (id: number): Movie | undefined => {
  return movies.find((m) => m.id === id);
};

export const getMoviesByCategory = (category: string): Movie[] => {
  return movies.filter((m) => m.category === category);
};

export const getFeaturedMovies = (): Movie[] => {
  return movies.filter((m) => m.featured);
};

export const getLatestMovies = (limit: number = 8): Movie[] => {
  return [...movies].sort((a, b) => new Date(b.releaseDate).getTime() - new Date(a.releaseDate).getTime()).slice(0, limit);
};

export const getRelatedMovies = (currentId: number, limit: number = 4): Movie[] => {
  return movies.filter((m) => m.id !== currentId).slice(0, limit);
};